(() => {
 function init(scope=document) {
  scope.querySelectorAll('[data-adv02-root]').forEach(root => {
   if (root.dataset.adv02Ready) return;
   root.dataset.adv02Ready='true';
   root.querySelectorAll('.faq-question').forEach(button => button.addEventListener('click',()=>{
    const open=button.getAttribute('aria-expanded')!=='true';
    button.setAttribute('aria-expanded',String(open));
    button.nextElementSibling.classList.toggle('is-open',open);
    button.querySelector('.faq-toggle').textContent=open?'−':'+';
   }));
   const bar=root.querySelector('[data-adv02-sticky]');
   if(!bar) return;
   const threshold=Number(root.dataset.stickyThreshold || 25)/100;
   const check=()=>{
    if(!root.isConnected) { window.removeEventListener('scroll',check);return; }
    const length=document.documentElement.scrollHeight-innerHeight;
    if(length<=0 || scrollY/length>=threshold) {
     bar.classList.add('is-visible');bar.removeAttribute('inert');window.removeEventListener('scroll',check);
    }
   };
   window.addEventListener('scroll',check,{passive:true});check();
  });
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
